import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { CmsItem } from "modules/cms/types/cmsItem";
import { getSectionDataThunk } from "./sectionDataActionAsync";

export type PagesSectionState = {
  isLoading: boolean;
  sectionInfo?: any;
};

export const sectionDataAdapter = createEntityAdapter<CmsItem>();

export const pagesSectionInitialState: PagesSectionState = {
  isLoading: false,
  sectionInfo: undefined,
};

export const { actions: sectionsActions, reducer: pagesSectionsReducer } = createSlice({
  name: "sectionData",
  initialState: pagesSectionInitialState,
  reducers: {
    clean: (state) => {
      state.sectionInfo = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSectionDataThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSectionDataThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.sectionInfo = payload?.JsonData
          ? { schema: payload.Type, info: JSON.parse(payload?.JsonData) }
          : undefined;
      });
  },
});
